import styled from 'styled-components';
import media from '../../../constants/media';

export const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	margin: auto;
	justify-content: space-around;
	gap: 4rem;
`;

export const IconBullet = styled.div`
	display: flex;
	flex-direction: row;
`;
export const BulletTextWrapper = styled.div`
	display: flex;
	flex-direction: column;
	margin-left: 2.25rem;

	${media.tablet`
		margin-left: 2.65rem;
	`};
	${media.desktopSmall`
		margin-left: 3.25rem;
	`};
`;

export const BulletText = styled.span`
	font-size: 1.9rem;
	line-height: 2rem;
	font-weight: 600;
	color: ${({ theme }) => theme.colors.grayTitle};
	font-family: ${({ theme }) => theme.fonts.ArimoRegular};
	margin: 0.8rem 0;

	${media.tablet`
		font-size: 2rem;
		line-height: 2.1rem;
	`};
	${media.desktopSmall`
		font-size: 2.1rem;
		line-height: 2.2rem;
	`};
`;
export const BulletSubtext = styled.span`
	font-size: 1.8rem;
	line-height: 1.9rem;
	font-weight: 500;
	color: ${({ theme }) => theme.colors.graySummary};
	font-family: ${({ theme }) => theme.fonts.ArimoRegular};

	${media.tablet`
		font-size: 1.7rem;
		line-height: 1.8rem;
	`};
	${media.desktopSmall`
		font-size: 1.8rem;
		line-height: 1.9rem;
	`};
`;

export const IconImage = styled.img`
	flex: 0 0 auto;
	width: 6.3rem;
	height: 6.3rem;
	// margin-bottom: 2rem;
`;

export const ImagePlaceholder = styled.div`
	flex: 0 0 auto;
	width: 10rem;
`;
